import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ModalController, NavController } from '@ionic/angular';
import { PosManagerMenuService } from 'src/app/components/pos-manager/menu/pos-manager-menu.service';
import { PosManagerConfirmModal } from 'src/app/modals';
import { ModalService } from 'src/app/services';

const DEFAULT_CONFIRM_BACK_MESSAGE =
  'Are you sure you want to exit? If you leave this screen, your data will not be saved.';

@Component({
  selector: 'pos-manager-header',
  templateUrl: './manager-header.component.html',
  styleUrls: ['./manager-header.component.scss']
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class ManagerHeaderComponent implements OnInit {
  @Input() color = 'dark';
  @Input() title: string;
  @Input() subtitle: string;
  @Input() hasBackButton = false;
  @Input() hasBackDetailedButton = false;
  @Input() confirmExit = false;
  @Input() confirmExitMessage: string = DEFAULT_CONFIRM_BACK_MESSAGE;
  @Input() hasCloseButton = false;
  @Input() backUrl: string;

  constructor(
    private readonly navController: NavController,
    private readonly modalController: ModalController,
    private readonly modalService: ModalService,
    private readonly posManagerMenuService: PosManagerMenuService,
    private readonly route: ActivatedRoute
  ) {}

  ngOnInit(): void {}

  async exit(data = null) {
    const hasBackBtn = this.hasBackButton || this.hasBackDetailedButton;
    const action = () =>
      hasBackBtn
        ? !this.backUrl
          ? this.navController.back()
          : this.navController.navigateBack([this.backUrl], {
              relativeTo: this.route
            })
        : this.modalController.dismiss(data);

    if (this.confirmExit) {
      await this.modalService.showModal(
        PosManagerConfirmModal,
        {
          description: DEFAULT_CONFIRM_BACK_MESSAGE
        },
        { cssClass: ['small-modal', 'dynamic-height-modal'] },
        ({ data: result }) => result?.deleted && action()
      );
    } else {
      action();
    }
  }

  async openMenu() {
    await this.posManagerMenuService.openMenu();
  }
}
